package org.catharsis.spendtel.feature.presentation.legal

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Checkbox
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import org.catharsis.spendtel.core.api.AnalyticsApi
import org.catharsis.spendtel.feature.data.EventName
import org.catharsis.spendtel.feature.presentation.expensereport.SpendTelReportColors
import org.koin.compose.koinInject

@Composable
fun LegalAcceptanceCheckbox(
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
    onPrivacyClick: () -> Unit,
    onTermsClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val analytics = koinInject<AnalyticsApi>()

    Row(
        modifier = modifier.fillMaxWidth(),
        verticalAlignment = Alignment.Top,
        horizontalArrangement = Arrangement.spacedBy(4.dp),
    ) {
        Checkbox(
            checked = checked,
            onCheckedChange = onCheckedChange,
        )

        Column(
            modifier = Modifier
                .weight(1f)
                .padding(top = 12.dp),
            verticalArrangement = Arrangement.spacedBy(4.dp),
        ) {
            Text(
                text = "I agree to the Terms & Conditions and Privacy Policy.",
                style = MaterialTheme.typography.bodySmall,
                color = SpendTelReportColors.inkMuted,
                lineHeight = MaterialTheme.typography.bodySmall.lineHeight,
            )
            Row(
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Text(
                    text = "Terms & Conditions",
                    style = MaterialTheme.typography.bodySmall,
                    color = SpendTelReportColors.violet,
                    fontWeight = FontWeight.Medium,
                    textDecoration = TextDecoration.Underline,
                    modifier = Modifier.clickable {
                        analytics.logClickEvent(EventName.CLICKED_TERMS)
                        onTermsClick()
                    },
                )
                Text(
                    text = "·",
                    style = MaterialTheme.typography.bodySmall,
                    color = SpendTelReportColors.inkMuted,
                )
                Text(
                    text = "Privacy Policy",
                    style = MaterialTheme.typography.bodySmall,
                    color = SpendTelReportColors.violet,
                    fontWeight = FontWeight.Medium,
                    textDecoration = TextDecoration.Underline,
                    modifier = Modifier.clickable {
                        analytics.logClickEvent(EventName.CLICKED_PRIVACY)
                        onPrivacyClick()
                    },
                )
            }
        }
    }
}
